import React, {forwardRef, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {getUserData} from "src/service/auth.service";
import useFetch, {CachePolicies} from "use-http";
import {Mentions, Popover, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

//@ts-ignore
import _ from "lodash";
import stickerBtn from "src/assets/png/newIcon/Home Feed/Comment/Emoji.png";
import styles from "./CommentToolbar.module.scss";
import GroupSticker from "./GroupSticker";
import uploadPhoto from "src/assets/png/newIcon/Home Feed/Comment/Camera.png";
import CoverPreview from "src/pages/Home/CreatePost/CoverPreview/CoverPreview";
import CoverPreviewContainer from "src/pages/Home/CreatePost/CoverPreview/CoverPreviewContainer";

import CenterButton from "src/components/shared/button/CenterButton";
import {getUrl} from "../../../service/files.service";
import {checkEmpty} from "../../../service/util.service";
import {getStickerSrc} from "../../../service/feed.sevice";

const { Option } = Mentions;

const COMMENT_TYPE = {
  TEXT: "text",
  STICKER: "sticker",
  IMAGE: "image",
};


const URLFileService = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER;

const MemberMention = (props: any) => {
  const { image, name } = props;
  return (
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        <div
            style={{
              width: 30,
              height: 30,
              backgroundImage: `url(${image})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              marginRight: 10,
            }}
        />
        <div
            style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {name}
        </div>
      </div>
  );
};

const CommentToolbar = forwardRef((props: any, ref: any) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [imageFile, setImageFile]: any = useState(null);
  const [isOpenSticker, setIsOpenSticker] = useState(false);
  const [friends, setFriends] = useState([]);

  const [previewImage, setPreviewImage]: any = useState(null);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [tempType, setTempType] = useState<string>("");
  const [tempStickerId, setTempStickerId] = useState<string>("");
  const [tempContent, setTempContent] = useState<string>("");

  const checkGetUrlFile = async () => {
    if (props.previousComment?.covers?.length > 0) {
      // c1ee9e5a-46f0-45ac-9f7f-e62abb9fbbc8
      console.log("props.previousComment?.covers[0]?.imageID", props.previousComment?.covers[0]?.imageID)
      let fileId = props.previousComment?.covers[0]?.imageID;
      //TODO
      // if (checkEmpty(fileId)) {
      //   fileId = "c1ee9e5a-46f0-45ac-9f7f-e62abb9fbbc8";
      // }
      let url: any =
          URLFileService +
          "/downloadFile?fileId=" +
          fileId +
          "&size=300";
      url = await getUrl(url, fileId, 300, "post");
      console.log("url", url);
      // setUrl300(url);
      setPreviewImage(null);
      setPreviewImage(url);
    } else {
      // setUrl300("")
      setPreviewImage(null)
    }
  };

  useEffect(() => {
    console.log("checkGetUrlFile")
    checkGetUrlFile();
    if (props?.previousComment?.type) {
      setTempType(props?.previousComment?.type);
      if (props?.previousComment?.type === COMMENT_TYPE.STICKER) {
        setTempStickerId(props?.previousComment?.stickerId);
        setTempContent(props?.previousComment?.content)
      }
    }
  }, [props.previousComment])

  useEffect(() => {
    if (props?.isEditComment && (previewImage || tempStickerId)) {
      setIsPreview(true);
    } else {
      setIsPreview(false);
    }
  }, [previewImage, props?.isEditComment, tempStickerId])

  useEffect(() => {

  }, [tempType, isPreview])

  useEffect(() => {
    console.log("tempStickerId", tempStickerId);
    if (previewImage) {
      setTempType(COMMENT_TYPE.IMAGE);
    } else if (tempStickerId) {
      console.log("tempStickerId2", tempStickerId);
      setTempType(COMMENT_TYPE.STICKER);
    } else {
      setTempType(COMMENT_TYPE.TEXT);
    }
  }, [previewImage, tempStickerId])

  const commentInputRef: any = useRef(null);

  const apiComment = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/comment/create",
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );

  const apiEditComment = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/comment/edit",
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );

  const apiFriends = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/friends",
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );

  const apiUploadFile = useFetch(
      window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadFile",
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
  );

  const loadingIcon = (
      <LoadingOutlined style={{ fontSize: "1rem", color: "#FFFFFF" }} />
  );

  const handleOpenSticker = () => {
    setIsOpenSticker(!isOpenSticker);
  };

  const createPreviewComment = (type: string, content: any) => {
    const userObj = {
      imageProfileURL: getUserData().imageProfileURL,
      firstname:
          getUserData().firstname +
          (_.isEmpty(getUserData().lastname) ? "" : " " + getUserData().lastname),
    };

    const newCommentObj: any = {
      content: type === COMMENT_TYPE.IMAGE ? "" : content,
      time: new Date(),
      user: userObj,
      type: type,
    };

    if (type === COMMENT_TYPE.IMAGE) {
      newCommentObj.covers = [{ imageID: content }];
    }

    props.onCommented?.(newCommentObj);
  };

  const handleCommentSticker = async (data: any) => {
    if (props?.isEditComment) {
      if (data?.stickerId) {
        setTempStickerId(data?.stickerId);
        setTempContent(data?.content);
      }
    } else {
      createPreviewComment(COMMENT_TYPE.STICKER, data.content);

      try {
        const res = await apiComment.post(data);
        let v = {
          id: props?.id,
          body: { res },
        };
        props?.webSocket.send(JSON.stringify(v));
      } catch (error) {
        console.error(error);
      }
    }
    setIsOpenSticker(false);

  };

  const filterMentionDetail = (message: string) => {
    if (message === "" || !message || message.length === 0) {
      return;
    }
    const mapList = [];
    const entityRanges = [];
    let offset = 0;
    let key = 0;
    let collecting = false;

    for (let i = 0; i < message.length; i++) {
      if (message.charAt(i) === "@") {
        offset = i;
        collecting = true;
      }

      if (collecting && message.charAt(i) === " ") {
        const keyword = message.substring(offset + 1, i);
        const userObj: any = friends.find((item: any) => {
          return item?.friend?.firstname === keyword;
        });
        const user = {
          name: keyword,
          userId: userObj?.friend.id,
          key: key.toString(),
        };
        const entityRange = {
          offset: offset,
          length: keyword.length + 1,
          key: key,
        };

        key += 1;
        mapList.push(user);
        entityRanges.push(entityRange);

        collecting = false;
      }
    }

    if (entityRanges.length === 0 && mapList.length === 0) return null;

    let rangeList: any = [];
    rangeList.push({
      entityRanges: entityRanges,
      key: "0",
      text: message,
    });

    const mentionObj = {
      rangeList: rangeList,
      mapList: mapList,
    };

    return mentionObj;
  };

  const isWhiteSpace = (comment: string) => {
    for (let i = 0; i < comment.length; i++) {
      if (comment.charAt(i) !== " " && comment.charAt(i) !== "\n") {
        return false;
      }
    }
    return true;
  };

  const handleComment = async (event: any) => {
    if (event.key === "Enter" && event.shiftKey) {
      console.log("11111");
      setComment((prev: string) => `${prev}\n`);
      return;
    }

    if (event.key === "Enter" && !props?.isEditComment) {
      createPreviewComment(COMMENT_TYPE.TEXT, comment);
      setComment("");

      if (previewImage) {
        handleCommentImage();
        return;
      }

      if (comment === "" || isWhiteSpace(comment) || comment === `\n`) {
        setComment("");
        return;
      }

      try {
        let mentionObj = filterMentionDetail(comment);
        let mentionStr = null;
        if (mentionObj) {
          console.log("comment:", mentionObj);
          mentionStr = JSON.stringify(mentionObj);
        }

        const commentObj = {
          feedID: props.id,
          content: comment,
          type: "text",
          mentionObj: mentionStr,
        };
        const res = await apiComment.post(commentObj);
        let v = {
          id: props?.id,
          body: { res },
        };
        props?.webSocket.send(JSON.stringify(v));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handlePreviewImage = (event: any) => {
    const file = event.target?.files?.[0];
    const url = URL.createObjectURL(file);
    setPreviewImage(url);
    setImageFile(file);
  };

  const handleCancelImage = () => {
    setPreviewImage(null);
    setImageFile(null);
    commentInputRef.current.value = "";
  };

  const handleCancelSticker = () => {
    setTempStickerId("");
    setTempContent("")
  }

  // useEffect(() => {
  //   console.log("previewImage", previewImage);
  // }, [previewImage])

  const handleCommentImage = async () => {
    setPreviewImage(null)
    let data = new FormData();
    data.append("file", imageFile);
    data.append("fullName", imageFile?.name);
    data.append("fileName", imageFile?.name?.split(".")[0]);
    data.append("fileType", imageFile?.name?.split(".")[1]);
    data.append("size", imageFile?.size);
    data.append("parent_folder_id", "");
    data.append("actionType", "comment");
    data.append("userId", getUserData()?.id);

    try {
      let uploadRes = await apiUploadFile.post(data);
      createPreviewComment(COMMENT_TYPE.IMAGE, uploadRes?.data?.id);
      handleCancelImage();

      let body = {
        feedID: props?.id,
        content: comment,
        type: "image",
        covers: [{ imageID: uploadRes?.data?.id }],
      };

      const res = await apiComment.post(body);
      let v = {
        id: props?.id,
        body: { res },
      };
      props?.webSocket.send(JSON.stringify(v));
      setComment("");
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelEditComment = () => {
    props?.onCancelEditComment();
    setComment("");
    setTempStickerId("");
    setTempContent("");
    setPreviewImage(null);
  };

  const handleEditComment = async () => {
    // if (comment === props?.previousComment?.content && !imageFile) {
    //   handleCancelEditComment();
    //   return;
    // }

    if (tempType === COMMENT_TYPE.TEXT && comment === "") {
      return;
    }

    setPreviewImage(null)

    let imageID: string = "";

    if (imageFile) {
      try {
        let data = new FormData();
        data.append("file", imageFile);
        data.append("fullName", imageFile?.name);
        data.append("fileName", imageFile?.name?.split(".")[0]);
        data.append("fileType", imageFile?.name?.split(".")[1]);
        data.append("size", imageFile?.size);
        data.append("parent_folder_id", "");
        data.append("actionType", "comment");
        data.append("userId", getUserData()?.id);

        let uploadRes = await apiUploadFile.post(data);
        createPreviewComment(COMMENT_TYPE.IMAGE, uploadRes?.data?.id);

        imageID = uploadRes?.data?.id;

        //TODO
        // if (imageFile && checkEmpty(imageID)) {
        //   imageID = "c1ee9e5a-46f0-45ac-9f7f-e62abb9fbbc8";
        // }
        handleCancelImage();
      } catch (e) {

      }
    }

    try {

      let mentionObj = filterMentionDetail(comment);
      let mentionStr = null;

      let commentObj: any = {
        id: props?.previousComment?.id,
        feedID: props.id,
        type: tempType,
        // content: comment,
        // stickerContent: comment
      };

      if (tempType !== COMMENT_TYPE.STICKER) {
        commentObj.content = comment;
      } else {
        console.log("commentObj.content", props)
        commentObj.content = props?.content;
        commentObj.stickerContent  = comment;
      }

      if (!checkEmpty(imageID)) {
        commentObj.covers = [{ imageID: imageID }]
      }

      if (tempStickerId) {
        commentObj.stickerId = tempStickerId;
        commentObj.content = tempContent;
        commentObj.stickerType = "default";
      }

      if (mentionObj) {
        mentionStr = JSON.stringify(mentionObj);
        commentObj.mentionObj = mentionStr;
      }

      const res = await apiEditComment.post(commentObj);
      console.log("edited comment");
      props?.onEdited(res);
      // let v = {
      //   id: props?.id,
      //   body: { res },
      // };
      // props?.webSocket.send(JSON.stringify(v));
      handleCancelEditComment();
    } catch (error) {
      console.error(error);
    }
  };

  const getFullName = (user: any) => {
    return `${user.firstname} ${user.lastname ? user.lastname : ""}`;
  };

  const loadFriendsData = async () => {
    try {
      const res = await apiFriends.get();
      if (apiFriends.response.ok) {
        setFriends(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (props?.previousComment !== null) {
      console.log("props.previousComment", props?.previousComment);
      if (props?.previousComment?.type === "sticker") {
        setComment(props?.previousComment?.stickerContent);
      } else {
        setComment(props?.previousComment?.content);
      }
    }
  }, [props?.previousComment]);

  useEffect(() => {
    console.log("props.previewCovers", props.previewCovers);
  }, [props.previewCovers])


  useEffect(() => {
    loadFriendsData();

    return () => {
      apiComment.abort();
      apiFriends.abort();
      apiUploadFile.abort();
    };
  }, []);

  return (
      <div className={styles.commentInputContainer} style={props.contentStyle}>
        <div className={styles.commentInput}>
          {/* <input
          type="text"
          placeholder={t("Write a comment")}
          value={comment}
          onChange={(event: any) => {
            setComment(event.target.value);
          }}
          onKeyPress={handleComment}
        /> */}

          <Mentions
              ref={ref}
              className={styles.mentionOverride}
              placement="top"
              placeholder={t("Write a comment")}
              value={comment}
              onChange={(text: any) => {
                if (text !== "\n") {
                  setComment(text);
                }
              }}
              onKeyPress={handleComment}
              autoSize={true}
              split={" "}
          >
            {friends?.map((item: any, idx: any) => {
              return (
                  <Option
                      value={item?.friend?.firstname}
                      key={item?.friend?.firstname}
                  >
                    <MemberMention
                        image={item?.friend?.imageProfileURL}
                        name={getFullName(item?.friend)}
                    />
                  </Option>
              );
            })}
          </Mentions>
          {!isPreview &&
              <Popover
                  open={isOpenSticker}
                  placement="topRight"
                  content={
                    <GroupSticker
                        onClickOutSide={() => {
                          setIsOpenSticker(false);
                        }}
                        onClickSticker={handleCommentSticker}
                        feedID={props.id}
                    />
                  }
              >
                <img
                    alt="preload"
                    src={stickerBtn}
                    style={{
                      height: "26px",
                      width: "26px",
                      cursor: "pointer",
                    }}
                    onClick={handleOpenSticker}
                />
              </Popover>
          }

        {!isPreview && !previewImage ?
          <div style={{ width: 23, height: 20, marginLeft: 10 }}>
            <input
              ref={commentInputRef}
              // value={commentInputRef ? commentInputRef.current.value : ""}
              type="file"
              accept="image/*"
              style={{
                width: "26px",
                height: "26px",
                position: "absolute",
                opacity: "0",
                cursor: "pointer",
              }}
              onChange={handlePreviewImage}
            />
            <div
              style={{
                width: "26px",
                height: "26px",
                backgroundImage: `url(${uploadPhoto})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                marginTop: "-3px",
              }}
            ></div>
          </div> : (!previewImage) && null
        }
      </div>

        <div style={{ width: "100%", height: "100%", paddingTop: "10px" }}>
          {previewImage && (
              <CoverPreviewContainer>
                <CoverPreview
                    close
                    coverUrl={previewImage}
                    coverType="image"
                    handleCloseCover={handleCancelImage}
                />
              </CoverPreviewContainer>
          )}

          {props?.isEditComment && tempStickerId &&
              <CoverPreviewContainer>
                <CoverPreview
                    close
                    coverUrl={getStickerSrc(tempStickerId)}
                    coverType="image"
                    width={"106px"}
                    height={"106px"}
                    handleCloseCover={handleCancelSticker}
                    // handleCloseCover={handleCancelImage}
                />
              </CoverPreviewContainer>
          }

          {/*{url300 && (*/}
          {/*    <CoverPreviewContainer>*/}
          {/*      <CoverPreview*/}
          {/*          close*/}
          {/*          coverUrl={url300}*/}
          {/*          coverType="image"*/}
          {/*          handleCloseCover={handleDeleteImage}*/}
          {/*      />*/}
          {/*    </CoverPreviewContainer>*/}
          {/*)}*/}

          {props?.isEditComment && (
              <div className={styles.editController}>
                <div className={styles.texEditComment}>
                  {t("Editing comment..")}
                </div>

                <div style={{ display: "inline-flex" }}>
                  <CenterButton small onClick={handleEditComment}>
                    {apiEditComment.loading ? (
                        <Spin indicator={loadingIcon} />
                    ) : (
                        t("Apply")
                    )}
                  </CenterButton>
                  <div style={{ marginLeft: 10 }}>
                    <CenterButton ghost small onClick={handleCancelEditComment}>
                      {t("Cancel")}
                    </CenterButton>
                  </div>
                </div>
              </div>
          )}
        </div>
      </div>
  );
});

export default CommentToolbar;
